const datasetDetailPanel = {
  meta: {
    rows: "Raðir",
    columns: "Dálkar",
    pseudonymized: "Dulnefnt",
    pseudonymizedRatio: "{{count}} af {{total}}",
    created: "Búið til",
    expires: "Gildistími",
    noExpiry: "Enginn",
  },
  columnsSectionLabel: "Dálkar",
  selectRowHint: "— veldu röð til að sjá samantektartölfræði",
  table: {
    column: "Dálkur",
    type: "Tegund",
    sensitivity: "Viðkvæmni",
    complete: "Fyllt út",
  },
  pseudonymizedBadge: "Dulnefnt",
  pseudonymizedBadgeTitle:
    "Upphaflega persónuupplýsingar ({{column}}) — gildin sem sjást eru dulnefni, ekki upprunalegu gögnin",
  stats: {
    min: "Lágmark",
    max: "Hámark",
    mean: "Meðaltal",
    median: "Miðgildi",
    stdDev: "Staðalfrávik",
  },
  categories: "Flokkar ({{count}})",
  moreCategories: "+{{count}} til viðbótar",
  uniqueValues_one: "{{formatted}} einstakt gildi",
  uniqueValues_other: "{{formatted}} einstök gildi",
  uniqueNoExposure: "— talið án þess að birta upprunalegu gildin",
  emptyCount: "· {{formatted}} tómt",
  legend:
    "Dulnefnt — þessi dálkur innihélt upphaflega persónuupplýsingar; gildunum var skipt út fyrir dulnefni áður en skráin fór í yfirlit gagnasafna.",
};

export default datasetDetailPanel;
